import { createEffect, createSignal, onMount } from 'solid-js'
import PopularCreators from './sections/PopularCreators'
import CreatorSpotlight from './sections/CreatorSpotlight'
import Footer from '/web/shared/aifans/Footer'
import Header from '/web/shared/aifans/Header'
import { characterStore } from '/web/store'
import { setComponentPageTitle } from '/web/shared/util'
import { AppSchema } from '/common/types'
import { Character } from '/common/types/library'
import HomeSpotlight from './sections/HomeSpotlight'
import { Meta, Title, Link } from '@solidjs/meta'

export default function Home() {
  const [scrolled, setScrolled] = createSignal(false)

  const chars = characterStore((s) => ({
    list: s.characters.list,
    map: s.characters.list.reduce<Record<string, AppSchema.Character>>(
      (prev, curr) => Object.assign(prev, { [curr._id]: curr }),
      {}
    ),
    loaded: s.characters.loaded,
    loading: s.loading,
  }))

  onMount(() => {
    if (!chars.loaded) {
      characterStore.getCharacters()
    }
  })

  createEffect(() => {
    if (window.scrollY > 10) {
      setScrolled(true)
    }
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  const getPageMetaTags = () => {
    return (
      <>
        <Title>CosplayFans - Exclusive Cosplay Content, Live Chats & More</Title>
        <Meta
          name="description"
          content="Join CosplayFans.ai for premium cosplay experiences! Enjoy exclusive content, live chats, and custom ai generated images."
        />
        <Meta
          name="og:title"
          content="CosplayFans - Exclusive Cosplay Content, Live Chats & More"
        />
        <Meta
          name="og:description"
          content="Join CosplayFans.ai for premium cosplay experiences! Enjoy exclusive content, live chats, and custom ai generated images."
        />
        <Meta name="og:url" content="https://www.cosplayfans.ai" />
        <Link rel="canonical" href="https://www.cosplayfans.ai" />
      </>
    )
  }

  return (
    <>
      {getPageMetaTags()}
      <div
        class={`fixed left-0 right-0 top-0 z-40 px-3 py-0 transition-all duration-100 sm:py-5 md:px-8 xl:px-16 ${
          scrolled()
            ? 'bg-[#0C0F12] md:bg-main/80 md:backdrop-blur-3xl'
            : 'bg-[#0C0F12] md:bg-transparent'
        }`}
      >
        <Header showMenu={true} />
      </div>
      <div class="mt-[58px] md:mt-0">
        <HomeSpotlight />
      </div>

      {/* popular creators */}
      <PopularCreators
        creators={chars.list.filter((c: Character) => c.category === 'popular')}
        title={
          <h2 class="lg:5xl text-2xl font-bold sm:text-3xl md:text-4xl">
            Popular On{' '}
            <span class="bg-home-gradient-header-text bg-clip-text text-transparent">
              CosplayFans
            </span>
          </h2>
        }
      />
      <CreatorSpotlight creators={chars.list.filter((c: Character) => c.category === 'creator')} />
      <PopularCreators
        creators={chars.list.filter((c: Character) => c.category === 'trending')}
        title={
          <h2 class="lg:5xl text-2xl font-bold sm:text-3xl md:text-4xl">
            <span class="bg-home-trending-gradient-text bg-clip-text text-transparent">
              Trending
            </span>{' '}
            Now
          </h2>
        }
      />
      <PopularCreators
        creators={chars.list.filter((c: Character) => c.category === 'online')}
        title={
          <h2 class="lg:5xl text-2xl font-bold sm:text-3xl md:text-4xl">
            Online{' '}
            <span class="bg-online-creators-gradient bg-clip-text text-transparent">Creators</span>
          </h2>
        }
      />
      <PopularCreators
        creators={chars.list.filter((c: Character) => c.category === 'new')}
        title={
          <h2 class="lg:5xl bg-anime-creators-gradient bg-clip-text text-2xl font-bold text-transparent sm:text-3xl md:text-4xl">
            Anime Creators
          </h2>
        }
      />
      <PopularCreators
        creators={chars.list.filter((c: Character) => c.category === 'hentai')}
        title={
          <h2 class="lg:5xl bg-anime-hentai-gradient bg-clip-text text-2xl font-bold text-transparent sm:text-3xl md:text-4xl">
            Hentai Creators
          </h2>
        }
      />
      <div class="mt-16">
        <Footer />
      </div>
    </>
  )
}
